/**
 * Freitext der Kasse für den Sync aufbereiten (U17d/f/g/h). Der Server prüft streng (`z.string().trim().max(n)` zählt
 * UTF-16-Einheiten, Steuerzeichen ergeben 400) und weist dann den GANZEN Stapel ab. Die Kasse fiele darauf in den Rückfall und
 * schickte Grund, Korrektur oder Artikel-Angaben gar nicht mehr. Deshalb bereitet die Kasse jeden Text so auf, dass der Server
 * ihn sicher annimmt: Steuerzeichen werden zu Leerzeichen (Zeilenumbrüche nur, wo erlaubt), und gekürzt wird nach ganzen
 * Zeichen, bis die Länge auch in UTF-16-Einheiten passt (ein Emoji wird nie halbiert). Leer ergibt `undefined`.
 */
export function clampFreeText(
  text: string | undefined,
  max: number,
  allowNewlines = false,
): string | undefined {
  const cleaned = Array.from(text ?? '')
    .map((char) => {
      const code = char.codePointAt(0) ?? 0;
      if (code >= 0x20) return char;
      return allowNewlines && (code === 0x0a || code === 0x0d) ? char : ' ';
    })
    .join('')
    .trim();
  if (cleaned === '') return undefined;
  const chars = Array.from(cleaned);
  let length = 0;
  let end = 0;
  for (const char of chars) {
    if (length + char.length > max) break;
    length += char.length;
    end += 1;
  }
  const result = chars.slice(0, end).join('').trim();
  return result === '' ? undefined : result;
}
